import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard, DiscardChangesGuard, LanguageResolver, BaseRouteComponent } from 'tms-lib';

const routes: Routes = [
  {
    path: '',
    component: BaseRouteComponent,
    canActivate: [AuthGuard, DiscardChangesGuard],
    resolve: { language: LanguageResolver },
    children: [
      { path: '', redirectTo: 'Home', pathMatch: 'full' },
      {
        path: 'Home',
        loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'Administration',
        loadChildren: () => import('./administration/administration.module').then((m) => m.AdministrationModule),
      },
      {
        path: 'Analysis',
        loadChildren: () => import('./analysis/analysis.module').then((m) => m.AnalysisModule),
      },
      {
        path: 'Documents',
        loadChildren: () => import('./documents/documents.module').then((m) => m.DocumentsModule),
      },
      {
        path: 'Fabrics',
        loadChildren: () => import('./fabric/fabric.module').then((m) => m.FabricModule),
      },
      {
        path: 'Production',
        loadChildren: () => import('./production/production.module').then((m) => m.ProductionModule),
      },
      {
        path: 'Purchasing',
        loadChildren: () => import('./purchasing/purchasing.module').then((m) => m.PurchasingModule),
      },
      {
        path: 'Reporting',
        loadChildren: () => import('./reporting/reporting.module').then((m) => m.ReportingModule),
      },
      {
        path: 'Sales',
        loadChildren: () => import('./sales/sales.module').then((m) => m.SalesModule),
      },
      {
        path: 'Settings',
        loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
      },
      {
        path: 'Stock',
        loadChildren: () => import('./stock/stock.module').then((m) => m.StockModule),
      },
      {
        path: 'UserAdmin',
        loadChildren: () =>
          import('../../../tms-lib/src/lib/user-admin/user-admin.module').then((m) => m.UserAdminModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
